import React, { useEffect, useRef, useState } from "react";
import Modal from "../../components/Modal";
import Checkbox from "../../components/Checkbox";
import Table, { Column, TableHandle } from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { PropertyType, setFilterData } from "../../redux/slices/PropertyType/slice";
import { Button } from "../../components/Button";
import { FaEdit } from "react-icons/fa";
import { LightColors } from "../../utils/colors/colors";
import { useNavigate } from "react-router-dom";
import CreateProprtyTypeModal from "./components/CreateProprtyTypeModal";
import { fetchPropertyTypeList } from "../../redux/slices/PropertyType/thunk";

const PropertyTypes = () => {
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate();
    const tableRef = useRef<TableHandle>(null);
    const {
        loading,
        propertyTypeList,
        filterData,
    } = useSelector((state: RootState) => state.propertyType)

    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedType, setSelectedType] = useState<PropertyType | null>(null)

    // Table columns for User
    const columns: Column<PropertyType>[] = [
        { key: "propertyType", label: "Property Type", sortable: true, },
        {
            key: "isActive",
            label: "Active",
            sortable: false,
            customCell: (row) => (
                <div className='flex'>
                    <Checkbox checked={row?.isActive} onCheckedChange={function (checked: boolean): void {

                    }} />

                </div>

            ),
        },
        {
            key: "action",
            label: "Actions", // Use a label or empty string if preferred
            sortable: false,
            customCell: (row) => (
                <div className='flex'>
                    <a
                        className="text-blue-600 cursor-pointer"
                        onClick={() => {
                            setSelectedType(row)
                            setShowAddModal(true)
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <FaEdit color={LightColors.accent} size={20} />
                    </a>
                </div>

            ),
        },
    ];


    const onPropertyTypeAdd = () => {

    }

      useEffect(() => {
        dispatch(fetchPropertyTypeList({
          ...filterData
        }))
      }, [
        filterData.page,
        filterData.limit,
        filterData.search,
        filterData.sortBy,
        filterData.sortOrder
      ]
      );

    return (
        <div>
            <Table
                ref={tableRef}
                columns={columns as any}
                data={propertyTypeList?.length ? propertyTypeList : []}
                tableName="Property Types"
                totalCount={filterData.totalCount || 0}
                currentPage={filterData.page}
                pageSize={filterData.limit}
                onSearchChange={(searchText) => {
                    dispatch(setFilterData({ ...filterData, search: searchText, page: 1 }));
                }}
                onPageChange={(page) => {
                    dispatch(setFilterData({
                        ...filterData,
                        page: page
                    }))
                }}
                onPageSizeChange={function (size: number): void {
                    dispatch(setFilterData({
                        ...filterData,
                        limit: size,
                        page:1
                    }))
                }}
                renderRightToolItems={
                    <div className='flex'>
                        <Button variant="primary" onClick={() => setShowAddModal(true)}>
                            Add
                        </Button>
                    </div>
                }
            />
            <CreateProprtyTypeModal
                setShowAddModal={setShowAddModal}
                isOpen={showAddModal}
                onPropertyTypeAdd={onPropertyTypeAdd}
                data={selectedType}
                onPropertyTypeAdded={()=>{
                    dispatch(fetchPropertyTypeList({
                        ...filterData
                      }))
                }}
            />
        </div>
    )
}

export default PropertyTypes
